import { createFileRoute } from '@tanstack/react-router';
import { GoogleRankingOverviewPage } from '@/features/marketing/google-ranking/overview/overview-page';

export const Route = createFileRoute('/_auth/$orgId/marketing/google-ranking/')({
  component: GoogleRankingOverviewRoute,
});

/** Marketing › Google Ranking › Overview (score, Maps rank grid, to-dos, review momentum, monthly report). */
function GoogleRankingOverviewRoute() {
  const { orgId } = Route.useParams();
  return <GoogleRankingOverviewPage routeOrgId={orgId} />;
}
